import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axios from 'axios';

function Home() {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate(); // Initialize useNavigate

  const [formData, setFormData] = useState({
    name: user?.name || '',
    lastName: '',
    state: '',
    phone: '',
    email: '',
  });

  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCommit = async () => {
    if (!formData.fname || !formData.email) {
      alert('Name and Email are required!');
      return;
    }

    try {
      await axios.post('/api/save-details', formData);
      setShowPopup(true); // Show the popup on success
    } catch (error) {
      console.error('Error saving file:', error.response || error.message);
      alert(`Failed to save data: ${error.response?.data || error.message}`);
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false); // Close the popup
    navigate('/facial-registration'); // Navigate to facial-registration
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <p>Welcome, {user?.name ?? 'User'}!</p>
      <p>Display Name: {user?.display_name ?? 'Not Available'}</p>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <tbody>
          {/* Input fields */}
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', borderBottom: '1px solid #ccc' }}>Name:</td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
              <input
                type="text"
                name="fname"
                value={formData.fname}
                onChange={handleInputChange}
                placeholder="Enter Name"
                style={{ width: '100%', padding: '5px' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', borderBottom: '1px solid #ccc' }}>Last Name:</td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter Last Name"
                style={{ width: '100%', padding: '5px' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', borderBottom: '1px solid #ccc' }}>State:</td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                placeholder="Enter State"
                style={{ width: '100%', padding: '5px' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', borderBottom: '1px solid #ccc' }}>Phone:</td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter Phone"
                style={{ width: '100%', padding: '5px' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', padding: '10px', borderBottom: '1px solid #ccc' }}>Email:</td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter Email"
                style={{ width: '100%', padding: '5px' }}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <button
        onClick={handleCommit}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
      >
        Continue 
      </button>

      {showPopup && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            padding: '20px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
            borderRadius: '8px',
            zIndex: 1000,
            textAlign: 'center',
          }}
        >
          <p>Thank you!</p>
          <button
            onClick={handlePopupClose}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Register you Face Vector
          </button>
        </div>
      )}
    </div>
  );
}

export default Home;

